export default "__VITE_ASSET__DW2JA_0m__"